import { useSelector } from "react-redux";
import { selectGeometryToAdd, selectSensorToAdd, selectUsedItemsInAssembly } from "./selector";

export const useSensorToAdd = () => useSelector(selectSensorToAdd);
export const useGeometryToAdd = () => useSelector(selectGeometryToAdd);
export const useUsedItemsInAssembly = () => useSelector(selectUsedItemsInAssembly);
